<template>
  <div id="app">
    <div class="link-btn" v-if="!isweb" @click="handleLink">
      <img src="@/assets/images/iphone.png" alt="">
    </div>
    <div class="pclink-btn" v-if="isweb" @click="handleLink">
      <img src="@/assets/images/web.png" alt="">
      <p>排污许可申领链接</p>
    </div>
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      isweb: true,
    }
  },
  mounted() {
    //浏览器放大缩小事件
    this.$nextTick(() => {
      this.resizeFun();
      // this.resizeFun窗口变化执行的方法
      window.addEventListener("resize", this.resizeFun);
      let screenWidth = document.body.clientWidth;
      let screenHeight = document.body.clientHeight;
      if (screenWidth < 1100) {
        this.isweb = false
      } else {
        this.isweb = true
      }
    });
  },
  methods: {
    resizeFun() {
      // 窗口变化执行的操作
      var screenWidth = window.innerWidth;
      if (screenWidth < 1100) {
        this.isweb = false
      } else {
        this.isweb = true
      }
    },
    handleLink(){
      window.open('https://permit.mee.gov.cn/')
    }
  },
}
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100%;
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  position: relative;
}

a {
  text-decoration: none !important;
}

.router-link-active {
  text-decoration: none !important;
}

.pclink-btn {
  width: 60px;
  height: auto;
  position: absolute;
  right: 20px;
  bottom: 40px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  z-index: 99;
  padding: 5px;
  box-sizing: border-box;
  cursor: pointer;

  img {
    width: 100%;
  }
  p{
    width: 100%;
    font-size: 12px;
    text-align: center;
  }
}

@media (max-width:500px) {
  .el-message-box {
    width: 280px !important;
  }

  .link-btn {
    position: absolute;
    bottom: 10%;
    left: 20px;
    width: 50px;
    height: 50px;
    border-radius: 25px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    z-index: 99;

    img {
      width: 100%;
    }
  }
}
</style>
